import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'

export const Twitter = (props: LevelProps) => {
  const isVirtualMarketer = useCurrentWorkspace()?.is_virtual_marketer

  return (
    <LevelPage
      {...props}
      cards={LEVEL_CARDS.L3.TWITTER.filter(
        (card) => !isVirtualMarketer || card.wizard !== GenerationType.TwitterPlanning,
      )}
    />
  )
}
